<template>
    <div>
        <form ref="companySettingsUpdate">
            <h5 class="mb-3 text-uppercase bg-light p-2">
            <i class="mdi mdi-office-building mr-1"></i>
            Icon Update
        </h5>
            <div class="col-md-6">
                <div class="form-group">
                    <label>Company Icon</label>
                    <div class="form-group">
                        <img v-bind:src="company.logo"
                             v-bind:alt="company.name"
                             width="100"
                             height="100"
                             class="img-fluid rounded">

                    </div>
                    <div class="form-group">
                        <vue-dropzone
                                id="iconDropZone"
                                ref="iconDropZone"
                                :options="iconDropZone"
                                @vdropzone-complete="refreshCompany"
                                v-on:vdropzone-sending="iconUploadEvent">
                        </vue-dropzone>
                    </div>
                    <div class="form-group">
                        <div class="button-list">
                            <button type="button"
                                    class="btn btn-success"
                                    @click="iconUpload">
                            <span class="btn-label"><i class="mdi mdi-upload"></i>
                            </span>Success
                            </button>

                            <button type="button"
                                    class="btn btn-danger"
                                    @click="iconRemove">
                        <span class="btn-label"><i class="mdi mdi-close-circle-outline"></i>
                        </span>Remove
                            </button>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label>Auth Token</label>
                    <div class="input-group">
                        <input type="text" placeholder="Auth token"
                               aria-label="Auth token" class="form-control" v-bind:value="company.tokenId">
                        <div class="input-group-append">
                            <button type="button" class="btn btn-blue" @click="updateToken">Change</button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>

  import vue2Dropzone from 'vue2-dropzone'
  import { companiesMethods } from '@state/helpers'

  import {
    required,
    minLength,
    maxLength,

  } from 'vuelidate/lib/validators'

  export default {
    components: { vueDropzone: vue2Dropzone },
    props: {
      company: {
        type: Object,
        default: null,
      },
      id: {
        type: Number,
        default: null,
      },
      companyData: {
        type: Function,
        default: null
      },
    },
    data() {
      return {
        submitted: false,
        gstFile: null,
        panFile: null,
        rocFile: null,
        iconDropZone: {
          url: 'https://api.99gift.in/admin/v1/company/updateDoc/',
          thumbnailWidth: 200, // px
          thumbnailHeight: 200,
          maxFilesize: 10,
          maxFiles: 1,
          autoProcessQueue: false,
          dictDefaultMessage: 'Icon Image',
          headers: { 'X-Token': window.localStorage.getItem('token') },
        },
      }
    },
    validations: {
      company : {
        webHookUrl: { required, minLength: minLength(32), maxLength: maxLength(32) },
        webHookKey: { required, minLength: minLength(32), maxLength: maxLength(32) },
      },
    },
    methods: {
      ...companiesMethods,

      iconUploadEvent (file, xhr, formData) {
        formData.append('file', 'logo');
      },


      iconUpload: function () {

        this.$refs.iconDropZone.setOption('url', 'https://api.99gift.in/admin/v1/company/updateDoc/'+this.id);
        this.$refs.iconDropZone.processQueue()
      },

      iconRemove: function () {

        this.$refs.iconDropZone.removeAllFiles();
      },

      refreshCompany: function () {
        this.companyData()
      },

      updateToken: async function (){

        try{
          const { success, message } = await this.changeToken(this.id);

          if(!success) throw new Error(message)
          this.companyData()
          this.appToast('Changed successfully!', message, 'success')
        }
        catch (e){
          this.appToast('Exception', e.message || 'Error while operating!', 'danger')
        }
      },
    },
  }
</script>